var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHoTestimonial1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.932 5.652C4.412 5.82 4.784 6.096 5.048 6.48C5.312 6.864 5.444 7.332 5.444 7.884C5.444 8.604 5.216 9.192 4.76 9.648C4.304 10.104 3.74 10.332 3.068 10.332C2.372 10.332 1.796 10.104 1.34 9.648C0.884 9.168 0.656 8.58 0.656 7.884C0.656 7.548 0.692 7.212 0.764 6.876C0.86 6.516 1.04 6 1.304 5.328L2.996 0.287998H5.264L3.932 5.652ZM10.736 5.652C11.216 5.82 11.588 6.096 11.852 6.48C12.116 6.864 12.248 7.332 12.248 7.884C12.248 8.604 12.02 9.192 11.564 9.648C11.108 10.104 10.544 10.332 9.872 10.332C9.176 10.332 8.6 10.104 8.144 9.648C7.688 9.168 7.46 8.58 7.46 7.884C7.46 7.548 7.496 7.212 7.568 6.876C7.664 6.516 7.844 6 8.108 5.328L9.8 0.287998H12.068L10.736 5.652Z",
    fill: "#CB202D",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoTestimonial1);
export default __webpack_public_path__ + "static/media/HoTestimonial1.6a50d8a3e73e9c085266d5599722e36f.svg";
export { ForwardRef as ReactComponent };